import React from "react";

export const AboutGradient = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 1920.24 1807.24"
        {...props}
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1={960.12}
            x2={960.12}
            y1={70.55}
            y2={1808}
            gradientTransform="matrix(1 0 0 -1 0 1808)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#e2ddef" />
        <stop offset={0.15} stopColor="#e3dfed" />
        <stop offset={0.56} stopColor="#ece9f2" />
        <stop offset={0.70} stopColor="#f1eff5" />
        <stop offset={0.90} stopColor="#fff" />
            
          </linearGradient>
          <style>{".cls-2{stroke-width:0;fill:#ccc}"}</style>
        </defs>
        <path
          d="M1920.24 0v1644.8c-211.35-20.39-425.6-30.82-642.3-30.82-437.19 0-864.47 42.45-1277.94 123.47V0h1920.24Z"
          style={{
            strokeWidth: 0,
            fill: "url(#linear-gradient)",
          }}
        />
        <path
          d="M1657 197.98V185.8h-12.18v-7.75H1657v-12.24h7.89v12.24h12.18v7.75h-12.18v12.18H1657ZM474.83 312.39v-5.77h-5.77v-3.68h5.77v-5.8h3.74v5.8h5.77v3.68h-5.77v5.77h-3.74ZM26.67 367.13v-5.77H20.9v-3.68h5.77v-5.8h3.74v5.8h5.77v3.68h-5.77v5.77h-3.74ZM524.51 716.2v-4.32h-4.32v-2.75h4.32v-4.35h2.8v4.35h4.32v2.75h-4.32v4.32h-2.8ZM1331.61 769.03v-4.32h-4.32v-2.75h4.32v-4.35h2.8v4.35h4.32v2.75h-4.32v4.32h-2.8ZM1033.87 317.25V313h-4.25v-2.7h4.25v-4.27h2.75v4.27h4.25v2.7h-4.25v4.25h-2.75ZM1778.86 364.02v-6.03h-6.03v-3.84h6.03v-6.07h3.91v6.07h6.03v3.84h-6.03v6.03h-3.91Z"
          className="cls-2"
        />
      </svg>
    </>
  );
};
